import React from "react";
import confirm from "~/assets/images/confirm.png";
import CustomeButton from "~/components/Button";
const ConfirmRegistration = ({ addNewEmployee, handleClose }) => {
  return (
    <div className="w-full confirm__registration">
      <img src={confirm} />
      <p className="m-0 heading">Employee registered</p>
      <p className="m-0 description">Your employee has been registered.</p>
      <div className="flex flex-column">
        <CustomeButton
          label={"Add New Employee"}
          icon="pi pi-plus"
          iconPos="right"
          variant="contained"
          className="access-btn"
          onClick={addNewEmployee}
        />
        <CustomeButton
          label={"Close"}
          className="access-btn"
          onClick={handleClose}
        />
      </div>
    </div>
  );
};

export default ConfirmRegistration;
